/* https://gist.github.com/filipesmedeiros/c10b3065e20c4d61ba746ab78c6a7a9e */
import type { ComponentProps, ReactElement } from "react";
import katex from "katex";
import type { KatexOptions, ParseError } from "katex";
import "katex/dist/katex.min.css";
import clsx from "clsx";

export type Props<T extends keyof JSX.IntrinsicElements = "div"> =
  ComponentProps<T> &
    Partial<{
      as: T;
      block: boolean;
      errorColor: string;
      renderError: (error: ParseError | TypeError) => ReactElement;
      settings: KatexOptions;
    }> & {
      math: string;
    };

export const TeX = ({
  children,
  math,
  block,
  errorColor,
  renderError,
  settings,
  as: asComponent,
  ...props
}: Props) => {
  const Component = asComponent || (block ? "div" : "span");
  const content = (children ?? math) as string;

  let innerHtml: string;
  try {
    innerHtml = katex.renderToString(content, {
      displayMode: !!block,
      errorColor,
      throwOnError: !!renderError,
      ...settings,
    });
  } catch (error) {
    if (error instanceof katex.ParseError || error instanceof TypeError) {
      if (renderError) {
        return renderError(error);
      } else {
        innerHtml = error.message;
      }
    } else {
      throw error;
    }
  }

  return (
    <Component
      {...props}
      className={clsx("text-sm", props.className)}
      dangerouslySetInnerHTML={{ __html: innerHtml }}
    />
  );
};
